import { USER_PROP, USER_SIGNUP_PROP } from "./constants";

export const checkLoginPassword = (password) => {
  return password.length >= 8;
};

export const checkValidReenteredPassword =(password, reenteredpassword) => {
  return password === reenteredpassword
}

export const checkEmailValid = (val) => {
  const reg = new RegExp(
    "^\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$"
  );
  return reg.test(val);
};
export const checkMultiEmailValid = (val) => {
  const result = val.split(",");
  for (let i = 0; i < result.length; i++) {
    if (!checkEmailValid(result[i])) {
      return false;
    }
  }
  return true;
};
/*  Minimum eight and maximum 20 characters, 
    at least one uppercase letter,
    one lowercase letter, 
    one number and one special character */
export const checkPasswordStrength = (val) => {
  const reg = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?#^&])[A-Za-z\\d@$!%*?#^&]{8,20}$"
  );
  return reg.test(val);
};
export const checkFieldValid = (field, value) => {
  switch (field) {
    case USER_PROP.FNAME:
    case USER_PROP.LNAME:
    case USER_PROP.COUNTRY:
    case USER_SIGNUP_PROP.AFFILIATION:
    case USER_PROP.ROLE:
      return !!value;
    case USER_PROP.EMAIL:
      return checkEmailValid(value);
    case USER_PROP.PASSWORD:
      return checkPasswordStrength(value);
    case USER_PROP.LOGINPASSWORD:
      return checkLoginPassword(value);
    case USER_SIGNUP_PROP.REPEAT_PASSWORD:
      return checkValidReenteredPassword(value[0], value[1]) 
    default:
      return false;
  }
};
